export const UNPROCESSED = 'unprocessed'
export const INDICATION_FAILURE = 'indication_failure'
export const DECLINED = 'declined'
export const STARTABLE_STATUSES = [UNPROCESSED, INDICATION_FAILURE]
export const DECLINE_REASON_MAX_LENGTH = 500

export const DRIVER_INDICATION_STATUSES = [
  { code: 'unprocessed', friendlyName: 'Aguardando Indicação' },
  { code: 'requested_indication', friendlyName: 'Indicação em Processamento' },
  { code: 'confirmed_indication', friendlyName: 'Indicação Confirmada' },
  { code: 'requested_driver', friendlyName: 'Solicitado confirmação do motorista' },
  { code: 'confirmed_driver', friendlyName: 'Confirmado o aceite do motorista' },
  { code: 'requested_check_indication', friendlyName: 'Verificação de Indicação' },
  { code: 'confirmed_check_indication', friendlyName: 'Verificação de Indicação Confirmada' },
  { code: 'indication_failure', friendlyName: 'Falha na Indicação' },
  { code: 'processed', friendlyName: 'Processado' },
  { code: 'deadline', friendlyName: 'Prazo Esgotado' },
  { code: 'denied_driver', friendlyName: 'Motorista recusou' },
  { code: 'inner_action', friendlyName: 'Ação Interna' },
  { code: 'declined', friendlyName: 'Não indicado por decisão do cliente' }
]

const LEGACY_CODE_MAP = {
  'aguardando_indicacao': 'unprocessed',
  'indicacao_em_processamento': 'requested_indication',
  'enviado_ao_orgao': 'confirmed_indication',
  'aguardando_retorno_orgao': 'requested_driver',
  'aguardando_pendencias_motorista': 'confirmed_driver',
  'recusado_pelo_motorista': 'denied_driver',
  'encerrado_interno': 'inner_action',
  'confirmado_pelo_orgao': 'processed'
}

export function translateStatus(code) {
  if (!code) return 'Aguardando Indicação'
  const normalizedCode = LEGACY_CODE_MAP[code] || code
  const status = DRIVER_INDICATION_STATUSES.find(s => s.code === normalizedCode)
  return status?.friendlyName || code
}

export function translateStatusWithDetails(code) {
  const statusMap = {
    'unprocessed': { name: 'Aguardando Indicação', description: 'Aguardando Indicação, nenhum processo realizado' },
    'requested_indication': { name: 'Indicação em Processamento', description: 'Requisidado a solicitação para realizar no portal' },
    'confirmed_indication': { name: 'Indicação Confirmada', description: 'Realizado a indicação no portal' },
    'requested_driver': { name: 'Solicitado confirmação do motorista', description: 'Requisidado a solicitação para confirmar o motorista para o Bot' },
    'confirmed_driver': { name: 'Confirmado o aceite do motorista', description: 'O motorista confirmou o aceite pelo o Bot' },
    'requested_check_indication': { name: 'Verificação de Indicação', description: 'Requisitado a verificação de indicação no portal' },
    'confirmed_check_indication': { name: 'Verificação de Indicação Confirmada', description: 'Realizado a verificação de indicação no portal' },
    'indication_failure': { name: 'Falha na Indicação', description: 'Não foi possível realizar a indicação no portal com os dados cadastrados' },
    'processed': { name: 'Processado', description: 'Processado, todos os processos foram realizados' },
    'deadline': { name: 'Prazo Esgotado', description: 'Prazo Esgotado, prazo para indicação esgotado' },
    'denied_driver': { name: 'Motorista recusou', description: 'Motorista recusou a indicação pelo o Bot' },
    'inner_action': { name: 'Ação Interna', description: 'Ação Interna, ação interna realizada' },
    'declined': { name: 'Não indicado por decisão do cliente', description: 'O cliente decidiu não indicar o condutor desta multa. A indicação foi encerrada por decisão do cliente, não por perda de prazo.' }
  }
  return statusMap[code] || { name: code, description: '' }
}

const HISTORY_ACTIONS = {
  created: 'Criação',
  updated: 'Atualização',
  declined: 'Não indicado por decisão do cliente',
  decline_undone: 'Não indicação desfeita'
}

export function translateHistoryAction(action) {
  return HISTORY_ACTIONS[action] || action || '-'
}

const padDatePart = value => String(value).padStart(2, '0')
const toIsoDate = date => [date.getFullYear(), padDatePart(date.getMonth() + 1), padDatePart(date.getDate())].join('-')

export function indicationDeadlineExpired(deadline, today = new Date()) {
  return Boolean(deadline) && String(deadline).slice(0, 10) < toIsoDate(today)
}

export function declineBlockReason(status, deadline, today = new Date()) {
  if (!status || !STARTABLE_STATUSES.includes(status.code))
    return 'Só é possível não indicar multas aguardando indicação ou com falha na indicação.'
  if (indicationDeadlineExpired(deadline, today))
    return 'Prazo de indicação expirado.'
  return null
}

export function canDecline(status, deadline, today = new Date()) {
  return !declineBlockReason(status, deadline, today)
}

export function canUndoDecline(status, deadline, today = new Date()) {
  return Boolean(status) && status.code === DECLINED && !indicationDeadlineExpired(deadline, today)
}

export function alreadyIndicated(indication, status) {
  if (!status) return Boolean(indication.protocol)

  return Boolean(status.closed) || !STARTABLE_STATUSES.includes(status.code)
}
